import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorFundUpdateReturn = () => {
  const { t } = useTranslation()
  const fundUpdateReturn = useCallback(
    (payload) => {
      ApiService.jsonRequest('/fund-bill/update-retur', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.return_approve_success')
                : t('response_message.return_reject_success'),
            timer: 2000,
            reload: true,
          })
        } else {
          showAlert({
            icon: 'warning',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.return_approve_failed')
                : t('response_message.return_reject_failed'),
            timer: 2000,
            reload: true,
          })
        }
      })
    },
    [t],
  )
  return { fundUpdateReturn }
}

export default InteractorFundUpdateReturn
